import { eventChannel } from 'redux-saga';
import {
  select, takeEvery, take, call, put,
} from 'redux-saga/effects';
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';

import {
  FETCH_NOTIFICATIONS,
  SEND_SYSTEM_NOTIFICATION_REQUESTED,
} from './actionTypes';

import {
  addSystemNotificationList,
  addSystemNotification,
  synchronizationStarted,
  sendSystemNotificationSucceeded,
  sendSystemNotificationFailed,
} from './actions';
import { addNotification } from '../notification/action';

import config from '../../config';

import { fetchUserNotifications, sendSystemNotification as sendSystemNotificationApi } from './api';

function initWebSocketChannel(userId) {
  return eventChannel((emitter) => {
    const socket = new SockJS(`${config.BACKEND_HOST}/ws`);
    const stompClient = Stomp.over(socket);
    stompClient.debug = null;

    stompClient.connect({}, () => {
      stompClient.subscribe(`/chat/notification/${userId}`, emitter);
    }, (error) => {
      console.log(error);
    });

    return () => {
      stompClient.disconnect();
    };
  });
}


function isSynchronized(state) {
  const { systemNotifications } = state;
  return systemNotifications.synchronized;
}

function getUser(state) {
  const { user } = state;
  return user;
}

function* fetchSystemNotifications() {
  try {
    const user = yield select(getUser);

    if (!(yield select(isSynchronized))) {
      const notificationList = yield call(fetchUserNotifications, user.id, user.token);
      yield put(addSystemNotificationList(notificationList));
      const notificationChannel = yield call(initWebSocketChannel, user.id);
      yield put(synchronizationStarted());
      while (true) {
        const notificationPayload = yield take(notificationChannel);
        yield put(addSystemNotification(JSON.parse(notificationPayload.body)));
      }
    }
  } catch (e) {
    yield put(addNotification('cantSynchronizeWithNotifications', config.notificationLevels.error));
  }
}

function* sendSystemNotification(action) {
  const user = yield select(getUser);
  try {
    const { receiversIdList } = action.payload;
    const { text } = action.payload;
    const senderId = user.id;

    const notificationList = receiversIdList.map(receiverId => ({
      receiverId,
      senderId,
      text,
    }));

    yield call(sendSystemNotificationApi, notificationList, user.token);
    yield put(sendSystemNotificationSucceeded());

    yield put(addNotification('notificationSend', config.notificationLevels.success, {}));
  } catch (err) {
    yield put(sendSystemNotificationFailed());
    yield put(addNotification('failedToSendNotification', config.notificationLevels.error, {}));
  }
}

export default function* watchSystemNotifications() {
  yield takeEvery(FETCH_NOTIFICATIONS, fetchSystemNotifications);
  yield takeEvery(SEND_SYSTEM_NOTIFICATION_REQUESTED, sendSystemNotification);
}



// WEBPACK FOOTER //
// ./src/services/systemNotifications/saga.js